import { createSlice } from "@reduxjs/toolkit";

import { getProgramData } from "../../services/api/robot";

import { novEyeVideos } from "../../libs/utils";

const videoSlice = createSlice({
  name: "videos",
  initialState: {
    fetching: false,
    fetchingError: null,
  },

  reducers: {
    fetchListRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchListFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchListSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
      videos: action.payload.videos,
    }),

    fetchRequest: (state) => ({
      ...state,
      fetching: true,
      fetchingError: null,
    }),

    fetchFailure: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: action.error,
    }),

    fetchSuccess: (state, action) => ({
      ...state,
      fetching: false,
      fetchingError: null,
    }),
  },
});

export const {
  fetchListRequest,
  fetchListFailure,
  fetchListSuccess,
  fetchRequest,
  fetchFailure,
  fetchSuccess,
} = videoSlice.actions;

export default videoSlice.reducer;

export const getRobotVideos = (id) => async (dispatch) => {
  try {
    dispatch(fetchListRequest());
    const { data } = await getProgramData(id === "171" ? 1 : id, "videos");

    const videos = novEyeVideos(data);
    dispatch(fetchListSuccess({ videos }));
  } catch (err) {
    dispatch(fetchListFailure(err.toString()));
  }
};
